/**
 * Hook to initialize a new transfer from an approved salenote.
 */
import { useState } from 'react'

import { customPost } from '../utils/customFetch'
import { TransferInitDto, TransferInitResponse } from '../interfaces/Transfer'

import { makeUrlTransferInit } from './connectionData'

const useTransferInit = () => {
  const [errorTransferInit, setErrorTransferInit] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const initTransfer = async (dto: TransferInitDto): Promise<TransferInitResponse | null> => {
    setLoading(true)
    try {
      const apiUrl = makeUrlTransferInit()
      const data = await customPost<TransferInitResponse>(apiUrl, dto)
      setErrorTransferInit(null)

      return data
    } catch (err) {
      const myErr = err instanceof Error ? err : new Error('Error desconocido')
      setErrorTransferInit(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  return { errorTransferInit, loading, initTransfer }
}

export default useTransferInit
